export const pages = {
  home: {
    title: 'Dashboard — Snagmatic',
    description: 'Track your infrastructure reports and citizen impact score.',
  },
  newReport: {
    title: 'Report an Issue — Snagmatic',
    description: 'Document a public infrastructure issue with photo, location, and category.',
  },
  myReports: {
    title: 'My Reports — Snagmatic',
    description: 'View and track the status of all your submitted civic issues.',
  },
  landing: {
    title: 'Snagmatic — Professional Infrastructure Reporting',
    description: 'Report public infrastructure issues directly to authorities in seconds. See it. Snap it. Sorted.',
  },
  login: {
    title: 'Sign In — Snagmatic',
    description: 'Sign in to track your infrastructure reports and citizen impact.',
  },
  privacy: {
    title: 'Privacy Policy — Snagmatic',
    description: 'How Snagmatic protects your privacy and data.',
  },
  terms: {
    title: 'Terms of Service — Snagmatic',
    description: 'Terms and conditions for using Snagmatic.',
  },
}

export const site = {
  name: 'Snagmatic',
  url: 'https://snagmatic.com',
  ogImage: 'https://snagmatic.com/icons/pwa-512x512.png',
  twitterHandle: '@snagmatic',
}
